import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AnalyticListLayer from "../../components/Analytic/AnalyticLayer";


const AnalyticList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Analytic & Reportings" />

        {/* AnalyticListLayer */}
        <AnalyticListLayer />

      </MasterLayout>

    </>
  );
};

export default AnalyticList; 
